import React, { Component } from 'react';
import BugReportModal from '../bug-report/BugReportModal';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      const { t } = this.props;
      return (
        <div>
          <h2>{t('somethingWentWrong')}</h2>
          <BugReportModal
            show={this.state.hasError}
            onClose={() => this.setState({ hasError: false, error: null, errorInfo: null })}
            exceptionDetails={this.state.error && this.state.error.toString()}
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
